import React, { Component } from 'react'
import { Input, Alert } from 'reactstrap'
import { DateRangePicker } from 'react-dates'
import addAccountLicense from '../../../helpers/users/licenses/addAccountLicense'
import { BeatLoader } from 'react-spinners'
import PropTypes from 'prop-types'
import moment from 'moment'

class AddLicensesRow extends Component {

  state = {
    startDate: null,
    endDate: null,
    focusedInput: null,
    quantity: '',
    licenseType: 'student',
    saving: false,
    error: '',
  }

  handleDatesChange = ({ startDate, endDate }) => this.setState({ startDate, endDate })
  focusInput = (focusedInput) => this.setState({ focusedInput })
  handleQtyChange = ({ target }) => this.setState({ quantity: target.value })
  handleTypeChange = ({ target }) => this.setState({ licenseType: target.value })

  handleSubmit = (e) => {
    e.preventDefault()
    const { startDate, endDate, quantity, licenseType, } = this.state
    const { license, district, accountId } = this.props
    // form validation
    if (!(quantity) || (parseInt(quantity) < 0)) {
      return this.setState({ error: 'Quantity must be set to a number.' })
    } else if (!startDate || !endDate) {
      return this.setState({ error: 'Start and end dates must be set.' })
    }
    this.setState({ saving: true })
    addAccountLicense({
      startDate: startDate.valueOf(),
      endDate: endDate.valueOf(),
      quantity: Math.round(quantity),
      licenseSet: license.id,
      licenseType,
      district,
      accountId,
      navName: license.navName,
      navCategory: license.navCategory,
      name: license.name,
    })
      .then(() => this.setState({ saving: false, error: '' }))
      .catch((error) => this.setState({ saving: false, error }))
  }

  render() {
    const { license } = this.props
    const {
      startDate,
      endDate,
      focusedInput,
      quantity,
      licenseType,
      saving,
      error
    } = this.state
    const {
      handleDatesChange,
      focusInput,
      handleQtyChange,
      handleSubmit,
      handleTypeChange
    } = this
    const START_DATE = 'startDate'
    const END_DATE = 'endDate'
    if (startDate && endDate) {
    }
    return (
      <React.Fragment>
        <tr>
          <td>{license.name}</td>
          <td>
          <Input
            name='licenseType'
            id='licenseType'
            type='select'
            value={licenseType}
            onChange={handleTypeChange}
          >
            <option value='student'>Student</option>
            <option value='educator'>Educator</option>
          </Input>
          </td>
          <td>
          <Input
            className="add-license-quantity"
            name='quantity'
            id='quantity'
            type='number'
            value={quantity}
            placeholder='How many licenses?'
            onChange={handleQtyChange}
            form='addform'
          />
          </td>
          <td>   
          <DateRangePicker
           ref={element => (this.fieldElement = element)}
           appendToBody
          startDate={startDate}
          startDateId={START_DATE}
          endDate={endDate}
          endDateId={END_DATE}
          onDatesChange={dates => handleDatesChange(dates)}
          onFocusChange={focus => focusInput(focus)}
          focusedInput={focusedInput}
          openDirection={'up'}
          numberOfMonths={1}
          isOutsideRange={() => false}
          renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
            <div style={{ display: 'flex', justifyContent: 'center', fontSize: '15' }}>
              <div>
                <select
                  value={month.month()}
                  onChange={(e) => { onMonthSelect(month, e.target.value); }}
                >
                  {moment.months().map((label, value) => (
                    <option value={value}>{label}</option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  value={month.year()}
                  onChange={(e) => { onYearSelect(month, e.target.value); }}
                >
                <option value={moment().year() - 6}>{moment().year() - 6}</option>
                <option value={moment().year() - 5}>{moment().year() - 5}</option>
                <option value={moment().year() - 4}>{moment().year() - 4}</option>
                <option value={moment().year() - 3}>{moment().year() - 3}</option>
                  <option value={moment().year() - 2}>{moment().year() - 2}</option>
                  <option value={moment().year() - 1}>{moment().year() - 1}</option>
                  <option value={moment().year()}>{moment().year()}</option>
                  <option value={moment().year() + 1}>{moment().year() + 1}</option>
                  <option value={moment().year() + 2}>{moment().year() + 2}</option>
                  <option value={moment().year() + 3}>{moment().year() + 3}</option>
                  <option value={moment().year() + 4}>{moment().year() + 4}</option>
                  <option value={moment().year() + 5}>{moment().year() + 5}</option>
                  <option value={moment().year() + 6}>{moment().year() + 6}</option>
                  <option value={moment().year() + 7}>{moment().year() + 7}</option>
                  <option value={moment().year() + 8}>{moment().year() + 8}</option>
                  <option value={moment().year() + 9}>{moment().year() + 9}</option>
                </select>
              </div>
            </div>
          )}
          small
        />
          </td>
          <td>
            <button className='license-btn' onClick={(e) => handleSubmit(e)} disabled={saving}>
              {saving ? <BeatLoader loading={saving} /> :
                <img
                  className='icon-plus'
                  src='/img/icon-license-add.svg'
                  alt='Add License' />
              }
            </button>
          </td>
        </tr> {error && <tr><td colSpan='12'><Alert color="warning">{error}</Alert></td></tr>}
      </React.Fragment>
    )
  }
}

AddLicensesRow.propTypes = {
  license: PropTypes.object.isRequired,
  district: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
}

export default AddLicensesRow


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/AddLicensesRow.js